import classNames from "classnames";
import { PropsWithChildren, ReactElement } from "react";
import { BusyIndicator } from "./BusyIndicator";
import styles from "./ContainerWithBusyIndicator.module.less";

export type ContainerWithBusyIndicatorProps = {
	hasBusyIndicator: boolean;
	size?: "auto" | "fill";
};

export const ContainerWithBusyIndicator = (props: PropsWithChildren<ContainerWithBusyIndicatorProps>): ReactElement => {
	const {
		hasBusyIndicator,
		size = "auto",
		children
	} = props;

	return (
		<div
			className={classNames(
				styles.root,
				{
					[styles.root_fill]: size === "fill"
				}
			)}
		>
			{ hasBusyIndicator && (
				<BusyIndicator />
			)}
			{ children }
		</div>
	);
};
ContainerWithBusyIndicator.displayName = "ContainerWithBusyIndicator";
